export default __webpack_public_path__ + "static/media/Chat-Numbers-System-11.5d84d51c.svg";